module.exports = __webpack_public_path__ + "static/media/amm3.a1ec45d2.jpg";